module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "bulk-client-add"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v(_vm._s('Bulk processing of clients'))]), _vm._v(" "), [_c('h4', [_vm._v(_vm._s(_vm.subTitle))]), _vm._v(" "), _c('el-table', {
    staticClass: "clients",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.clients
    }
  }, [(_vm.type === 'isSubClient') ? _c('el-table-column', {
    attrs: {
      "label": "$t('static.clients.table.parentClient)",
      "width": "200",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-select', {
          attrs: {
            "filterable": "",
            "remote": "",
            "placeholder": "Please enter a keyword",
            "remote-method": function (query) { return _vm.searchMethod(query, props.row.id); },
            "loading": _vm.optionsLoading
          },
          on: {
            "change": function (value) { return _vm.onClientParent(value, props.row.id); }
          },
          model: {
            value: (props.row.clientParent),
            callback: function($$v) {
              _vm.$set(props.row, "clientParent", $$v)
            },
            expression: "props.row.clientParent"
          }
        }, _vm._l((_vm.clientOptions), function(item, index) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }], null, false, 3002562091)
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'isSubClient') ? _c('el-table-column', {
    attrs: {
      "label": "$t('static.clients.table.billMainParent)",
      "width": "150",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-checkbox', {
          attrs: {
            "value": props.row.billMainParent
          },
          on: {
            "change": function (value) { return _vm.onBillMainParent(value, props.row.id); }
          }
        }, [_vm._v("Bill main parent")])]
      }
    }], null, false, 2306019296)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": _vm.$t('static.clients.table.name'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "billType",
      "label": _vm.$t('static.clients.table.billType'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "email",
      "label": _vm.$t('static.clients.table.email'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "ordersCount",
      "label": _vm.$t('static.clients.table.ordersCount'),
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "small dark",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.proceed')))])], 1)]], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7324272b","hasScoped":false}!./src/app/components/bulkProcessClientModal/bulkProcessClientModal.html
// module id = 3065
// module chunks = 1